import React from 'react'

/**
 * Props for the MoveSwimlaneComponent
 */
export interface IMoveSwimlaneProps {
    showLeft: boolean
    showRight: boolean
    onLeft: () => void
    onRight: () => void
    onDone: () => void
}

/**
 * Displays as a layer over the top of a swimlane and provides the functionality
 * to move it's position in the board.
 * @param props {IMoveSwimlaneProps} properties for the move swimlane component
 */
function MoveSwimlaneComponent(props: IMoveSwimlaneProps) {
    return (
        <div className="container h-100">
            <div className="row h-100 pt-3">
                <div className="col">
                    {props.showLeft && (
                        <button
                            className="btn btn-primary w-100"
                            type="button"
                            onClick={props.onLeft}>
                            Left
                        </button>
                    )}
                </div>
                <div className="col">
                    <button
                        className="btn btn-primary w-100"
                        type="button"
                        onClick={props.onDone}>
                        Done
                    </button>
                </div>
                <div className="col">
                    {props.showRight && (
                        <button
                            className="btn btn-primary w-100"
                            type="button"
                            onClick={props.onRight}>
                            Right
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export { MoveSwimlaneComponent as default }
